import Api from './apis/Api.js';

const state = {
    clients: [],
    projects: [],
    contacts: [],
    salespersons: [],
    users: [],
    tasks: [],
    subscriptions: [],
    user: {},
    snackbar1: {
        snackbar: false,
        text: '',
        color: '',
        timeout: 3000,
    }
};

const getters = {
    allclients: state => state.clients,
    allprojects: state => state.projects,
    allcontacts: state => state.contacts,
    allsalespersons: state => state.salespersons,
    allusers: state => state.users,
    alltasks: state => state.tasks,
    allsubscriptions: state => state.subscriptions,
    currentuser: state => state.user,
    snackbar: state => state.snackbar1,
};

//var url = "http://projectmgmt.clarionit.in";
//var url = "http://localhost/project/public";

const actions = {
    async fetchclients({ commit }) {
        const response = await Api().get('/clients');

        commit('setclients', response.data.data);
    },
    async fetchprojects({ commit }) {
        const response = await Api().get('/projects');

        commit('setprojects', response.data.data);
    },
    async fetchusers({ commit }) {
        const response = await Api().get('/users');

        commit('setusers', response.data.data);
    },
    async fetchcontacts({ commit }) {
        const response = await Api().get('/contacts');

        commit('setcontacts', response.data.data);
    },
    async fetchsalespersons({ commit }) {
        const response = await Api().get('/salespeople');

        commit('setsalespersons', response.data.data);
    },
    async fetchtasks({ commit }) {
        const response = await Api().get('/tasks');
        commit('settasks', response.data.data);
    },
    async fetchsubscriptions({ commit }) {
        const response = await Api().get('/subscriptions');
        commit('setsubscriptions', response.data.data);
    },
    async fetchuser({ commit }) {
        const response = await Api().get('/user');

        commit('currentuser', response.data);
    },
    async addclient({ commit }, customer1) {
        await Api().post('/clients',customer1).then((response) => {
            commit('addclient', customer1);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
    },
    async editclient({ commit }, customer1) {
        await Api().put('/clients/' + customer1.id, customer1).then((response) => {
            commit('editclient', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
        
    },
    async deleteclient({ commit }, customer1) {
        commit('deleteclient', customer1);
    },
    async addproject({ commit }, project) {
        await Api().post('/projects', project).then((response) => {
            commit('addproject', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });

    },
    async addprojectcontact({ commit }, contact) {
        await Api().post('/project_client_contacts', contact).then((response) => {
            commit('addprojectcontact', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
        
    },
    async addprojectcomments({ commit },{projectid, comment}) {
        await Api().post('/projects/' + projectid + '/comments/create', comment).then((response) => {
            commit('addprojectcomment', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
        
    },
    async editproject({ commit }, project) {
        await Api().put('/projects/' + project.id, project).then((response) => {
            commit('editproject', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
    },
    async deleteproject({ commit }, project) {
        commit('deleteproject', project);
    },
    async addcontact({ commit },contact) {
        await Api().post('/contacts', contact).then((response) => {
            commit('addcontact', { contact: response.data.data, projectid: contact.project_id });
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
        
    },
    async editcontact({ commit }, {contact,projectid}) {
        await Api().put('/contacts/' + contact.id, contact).then((response) => {
            commit('editcontact', { contact: response.data.data, projectid: projectid });
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });

    },
    async deletecontact({ commit }, contact) {
        commit('deletecontact', contact);
    },
    async addsalesperson({ commit }, saleperson) {
        commit('addsalesperson', saleperson);
    },
    async editsalesperson({ commit }, saleperson) {
        commit('editsalesperson', saleperson);
    },
    async deletesalesperson({ commit }, saleperson) {
        commit('deletesalesperson', saleperson);
    },
    async addtask({ commit }, task) {
        await Api().post('/tasks', task).then((response) => {
            commit('addtask', { task: response.data.data, projectid: task.project_id });
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        }); 
    },
    async edittask({ commit }, task) {
        await Api().put('/tasks/' + task.id + '', task)
            .then((response) => {
                commit('edittask', { task: response.data.data, projectid: task.project_id });
                commit('showsnackbar', { message: response.data.message, color: 'success' });
            }).catch((error) => {
                commit('showsnackbar', { message: error, color: 'error' });
            });
    },
    async addsubscription({ commit }, subscription) {
        await Api().post('/subscriptions', subscription).then((response) => {
            commit('addsubscription', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
    },
    async editsubscription({ commit }, subscription) {
        await Api().put('/subscriptions/'+subscription.id+'', subscription)
            .then((response) => {
                commit('editsubscription', response.data.data);
                commit('showsnackbar', { message: response.data.message, color: 'success' });
            }).catch((error) => {
                commit('showsnackbar', { message: error, color: 'error' });
            });
    },
    async addpayment({ commit },payment) {
        await Api().post('/subscription_payments', payment).then((response) => {
            commit('addpayment', { payment: response.data.data, subscriptionid: payment.subscription_id });
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
    },
    async addprojectfiles({ commit }, {formData,projectid}) {
        await Api().post('/projects/'+projectid+'/files/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            commit('addprojectfile', response.data.data);
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });

    },
    async deletefiles({ commit }, {fileid,projectid}) {
        const response = await Api().delete('/files/' + fileid).then((response) => {
            commit('deletefile', { fileid: fileid, projectid: projectid });
            commit('showsnackbar', { message: response.data.message, color: 'success' });
        }).catch((error) => {
            commit('showsnackbar', { message: error, color: 'error' });
        });
        console.log(response);  
    },
    showsnackbar({ commit },{message,color}) {
        commit('showsnackbar', { message: message, color: color });
    }

};

const mutations = {
    setclients: (state, customers) => (state.clients = customers),
    addclient: (state, customer1) => (state.clients.push(customer1)),
    editclient: (state, customer1) => {
        const index = state.clients.findIndex(product => product.id === customer1.id);
        state.clients.splice(index, 1, customer1);
        state.projects.map((project,index) => {
            if(project.client_id == customer1.id)
            {
                state.projects[index].client = customer1;
            }
        });
    },
    deleteclient: (state, customer1) => {
        const index = state.clients.findIndex(product => product.id === customer1.id);
        state.clients.splice(index, 1);
    },
    setprojects: (state, products) => (state.projects = products),
    addproject: (state, project) => (state.projects.push(project)),
    editproject: (state, project) => {
        const index = state.projects.findIndex(product => product.id === project.id);
        state.projects.splice(index, 1, project);
    },
    deleteproject: (state, project) => {
        const index = state.projects.findIndex(product => product.id === project.id);
        state.projects.splice(index, 1);
    },
    setcontacts: (state, contacts) => (state.contacts = contacts),
    addcontact: (state, {contact,projectid}) => {
        state.contacts.push(contact);
        const index1 = state.projects.findIndex(product => product.id === projectid);
        state.projects[index1].contacts.push(contact);
    },
    editcontact: (state, {contact,projectid}) => {
        const index0 = state.clients.findIndex(product => product.id === contact.id);
        state.clients.splice(index0, 1, contact);
        const index1 = state.projects.findIndex(product => product.id === projectid);
        const index2 = state.projects[index1].contacts.findIndex(contact1 => contact1.id === contact.id);
        state.projects[index1].contacts.splice(index2, 1, contact);
        state.projects.map((project, index) => {
            if (project.client_id == contact.id && index != index1) {
                const index3 = state.projects[index].contacts.findIndex(contact1 => contact1.id === contact.id);
                state.projects[index].contacts.splice(index3, 1, contact); 
            }
        });
    },
    deletecontact: (state, contact) => {
        const index = state.contacts.findIndex(product => product.id === contact.id);
        state.contacts.splice(index, 1);
    },
    setsalespersons: (state, salespersons) => (state.salespersons = salespersons),
    addsalesperson: (state, saleperson) => (state.salespersons.push(saleperson)),
    editsalesperson: (state, saleperson) => {
        const index = state.salespersons.findIndex(product => product.id === saleperson.id);
        state.salespersons.splice(index, 1, saleperson);
    },
    deletesalesperson: (state, saleperson) => {
        const index = state.salespersons.findIndex(product => product.id === saleperson.id);
        state.salespersons.splice(index, 1);
    },
    settasks: (state, tasks) => (state.tasks = tasks),
    addtask: (state, {task,projectid}) => {
        state.tasks.push(task);
        const index1 = state.projects.findIndex(product => product.id === projectid);
        state.projects[index1].tasks.push(task);
    },
    edittask: (state, {task,projectid}) => {
        const index0 = state.tasks.findIndex(product => product.id === task.id);
        state.tasks.splice(index0, 1, task);
        console.log(projectid);
    },
    currentuser: (state,user) => (state.user = user),
    setusers: (state, users) => (state.users = users),
    addprojectcontact: (state, contact) => {
        const index = state.projects.findIndex(project => project.id === contact.project_client_contact_id);
        state.projects[index].contacts.push(contact.contact);
    },
    addprojectcomment: (state, comment) => {
        const index = state.projects.findIndex(project => project.id === comment.commentable_id);
        state.projects[index].comments.push(comment);
    },
    addprojectfile: (state,file) => {
        const index = state.projects.findIndex(project => project.id === file.fileable_id);
        state.projects[index].files.push(file);
    },
    deletefile: (state,{fileid,projectid}) => {
    const index = state.projects.findIndex(product => product.id === projectid);
    const index1 = state.projects[index].files.findIndex(file => file.id === fileid);
    state.projects[index].files.splice(index1,1);
    },
    showsnackbar: (state,{ message,color}) => {
        state.snackbar1.text = message;
        state.snackbar1.color = color;
        state.snackbar1.snackbar = true;
    },
    setsubscriptions: (state, subscriptions) => (state.subscriptions = subscriptions),
    addsubscription: (state, subscription ) => {
        state.subscriptions.push(subscription);
    },
    editsubscription: (state, subscription) => {
        const index0 = state.subscriptions.findIndex(product => product.id === subscription.id);
        state.subscriptions.splice(index0, 1, subscription);
    },
    addpayment: (state,{payment,subscriptionid}) => {
        const index0 = state.subscriptions.findIndex(product => product.id === subscriptionid);
        state.subscriptions[index0].subscription_payment.push(payment);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}